// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const ContractViewLayout = ({ children }) => {

	return (
		<div className='ContractViewLayout'>
			
			<Header/>

			<Container>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ContractViewLayout.propTypes = {
	children: PropTypes.node,
}

ContractViewLayout.defaultProps = {
	children: null,
}

export default ContractViewLayout;